import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ForcedPasswordChange from './ForcedPasswordChange';

const ForcePasswordChangeRoute = () => {
  const { forcePasswordChange } = useAuth();

  // If password change is required, render the ForcedPasswordChange component
  if (forcePasswordChange) {
    return <ForcedPasswordChange />;
  }

  // Otherwise, continue with the normal protected routes
  return <Outlet />;
};

export default ForcePasswordChangeRoute;